/******/ (() => { // webpackBootstrap
/* eslint-disable */
// BSF-CUSTOM (atc-bind-first): these globals come from vendors.js; if it failed to load, an
// unguarded throw here would stop the file before the DOMContentLoaded handler (and its
// Add to Cart binding) is ever registered.
try {
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
} catch (error) {
  console.error('[BSF] vendor bootstrap failed; continuing so Add to Cart still binds', error);
}

// Lightbox default options, applied once right after fancybox.js loads
// (fancybox is loaded on demand by window.loadFancybox in utilities).
// https://fancyapps.com/fancybox/3/docs/#options
window.setupFancyboxDefaults = function () {
  if (window.fancyboxDefaultsApplied || !$.fancybox) {
    return;
  }
  window.fancyboxDefaultsApplied = true;
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };
};

// Resize-on-image-load patch for Flickity, applied once right after
// flickity.js loads (flickity is loaded on demand by window.loadFlickity in
// utilities). Must run before any slider is initialized.
window.setupFlickityPatch = function () {
  if (window.flickityPatchApplied || !window.Flickity) {
    return;
  }
  window.flickityPatchApplied = true;
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };
};
document.addEventListener('DOMContentLoaded', function () {
  /* BSF-CUSTOM · atc-bind-first · since 2026-09-21
     WHAT:  the ajax Add to Cart binding (and the two cart-refresh variables refreshCart reads) run
            FIRST in this handler instead of last. refreshCart itself is a hoisted function
            declaration further down, so it needs no move.
     WHY:   this handler is ~640 lines of unguarded init; a throw anywhere before its last statement
            used to leave a visible Add to Cart that does nothing (ajax mode renders it type=button)
            - the class of the 2026-09-04 outage. The `let`s moved too: left below a throw they stay
            in the temporal dead zone and refreshCart would throw after a successful add.
     MERGE: keep this block at the top of the handler; take vendor edits to its body. */
  // Rapid quantity changes fire overlapping refreshes. Abort drops the request;
  // the id catches a response that landed before the abort could apply.
  let cartRefreshRequest = null;
  let cartRefreshId = 0;
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    /* BSF-CUSTOM · atc-a11y · since 2026-09-29
       WHAT:  a polite status region that says what was added; focus moves into the mini-cart when an
              add opens it, Escape closes it and returns focus; errors are plain English, role=alert,
              scrolled into view, and parsed with JSON.parse instead of eval; reduced-motion respected.
       WHY:   screen-reader users heard nothing after Add to Cart, focus fell to <body> while the button
              was disabled, and an error under the main form was off-screen when the add came from the
              sticky bar.
       MERGE: keep these helpers and their three call sites (success, drawer open, error) if vendor
              rewrites the handler. closeMiniCart lives in sections.js scope, so Escape repeats its
              class changes here. */
    // Never throw here: nothing may fail before the .ajax-submit binding below (atc-bind-first).
    const bsfStatusEl = () => {
      try {
        let r = document.getElementById('bsf-cart-status');
        if (!r && document.body) {
          r = document.createElement('div');
          r.id = 'bsf-cart-status';
          r.className = 'visually-hidden';
          r.setAttribute('role', 'status');
          r.setAttribute('aria-live', 'polite');
          document.body.appendChild(r);
        }
        return r;
      } catch (err) { return null; }
    };
    bsfStatusEl(); // create early so the live region exists before its first update
    const bsfAnnounce = msg => {
      const r = bsfStatusEl();
      if (!r) return;
      r.textContent = '';
      window.setTimeout(() => { r.textContent = msg; }, 60);
    };
    const bsfAddedText = data => {
      const items = data && data.items ? data.items : (data ? [data] : []);
      if (!items.length) return 'Added to cart.';
      return 'Added to cart: ' + items.map(it => {
        const v = it.variant_title && it.variant_title !== 'Default Title' ? ', ' + it.variant_title : '';
        return (it.product_title || it.title || 'item') + v + ', quantity ' + (it.quantity || 1);
      }).join('; ') + '.';
    };
    let bsfCartReturnFocus = null;
    $(document).on('keydown', e => {
      if (e.key !== 'Escape' || !$('.cart-container.active_link').length) return;
      $('body').removeClass('is-active').removeClass('blocked-scroll');
      $('.cart-container').removeClass('active_link');
      const back = bsfCartReturnFocus && document.body.contains(bsfCartReturnFocus) ? bsfCartReturnFocus : document.querySelector('.mini_cart');
      bsfCartReturnFocus = null;
      if (back) back.focus();
    });
    /* /BSF-CUSTOM · atc-a11y (helpers) */
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      $('.warning').remove();
      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }
      const bsfAddOptions = { // BSF-CUSTOM - addon-menus: named so the menu hook below reuses these callbacks
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success(added) {
          try { bsfAnnounce(bsfAddedText(added)); } catch (err) { /* never block the add */ } // BSF-CUSTOM · atc-a11y
          bsfCartReturnFocus = $addToCartBtn[0] || null;
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart).then(function () {
                  if ($.fancybox && $('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }
                  // BSF-CUSTOM (atc-bind-first): if header init never ran (an earlier throw), #header
                  // has no drawer to open and no close handlers - opening it and scroll-locking would
                  // strand a phone user on a frozen page. The cart count is already refreshed.
                  if ($('#header').is(':visible') && !$('#header .cart_content').length) return;
                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  } else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }
                  // BSF-CUSTOM · atc-a11y: move focus into the drawer the add just opened.
                  const bsfDrawer = $('.cart-container.active_link .cart_content:visible')[0];
                  if (bsfDrawer) {
                    bsfDrawer.setAttribute('role', 'dialog');
                    bsfDrawer.setAttribute('aria-label', 'Cart');
                    bsfDrawer.setAttribute('tabindex', '-1');
                    bsfDrawer.focus({ preventScroll: true });
                  }

                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' // BSF-CUSTOM · atc-a11y
                      });
                    }
                  }
                });
              }, 500);
            }
          });
        },
        error: XMLHttpRequest => {
          // BSF-CUSTOM · atc-a11y: JSON.parse (not eval), plain-English alert, kept in view.
          let response = {};
          try { response = JSON.parse(XMLHttpRequest.responseText) || {}; } catch (err) { response = {}; }
          $('.warning').remove();
          if (response.errors && response.errors.email && this.recipientForm) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            const detail = String(response.description || response.message || 'Something went wrong.').replace('All 1 ', 'All ');
            const $warning = $('<p class="warning animated bounceIn" role="alert"></p>')
              .text(`Couldn't add that to your cart: ${detail} Questions? Call (888) 406-1982.`);
            $addToCartForm.after($warning);
            const w = $warning[0];
            const box = w.getBoundingClientRect();
            if (box.top < 0 || box.bottom > window.innerHeight) w.scrollIntoView({ block: 'center' });
          }
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          if (document.activeElement === document.body && $addToCartBtn[0]) $addToCartBtn[0].focus();
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      };
      /* BSF-CUSTOM - addon-menus - since 2026-10-18
         WHAT:  a form holding an add-on menu ([data-bsf-addon-menu], rendered only when the theme setting
                addon_menus_enabled and the product's menu are on) adds through assets/bsf-addon-menu.js: kit +
                nested add-ons (parent_id) in one JSON /cart/add.js, or a merge into the same configuration
                (_bsf_cfg) already in the cart. It reuses the callbacks above, so the drawer, status message and
                error alert are unchanged. An error BEFORE anything is sent falls back to the plain add (kit only)
                with a visible note; after a request is sent it never retries - the menu re-reads /cart.js and says
                what did and didn't get added.
         WHY:   replacing ITORIS DPO (BsfOrderHandler Dev/AddonMenus.md).
         MERGE: keep this block between the options object and the $.ajax call; forms without a menu skip it.
                The menu renders only on the main product page (never the cart page or quick shop). */
      const bsfMenuRoot = $addToCartForm[0].querySelector('[data-bsf-addon-menu]');
      if (bsfMenuRoot) {
        const bsfFallback = () => {
          const hadChoices = Array.prototype.some.call(bsfMenuRoot.querySelectorAll('select'), s => s.value !== '');
          $.ajax(Object.assign({}, bsfAddOptions, {
            data: $addToCartForm.find(':input').not('[data-bsf-addon-express] :input').serialize(),
            success(added) {
              bsfAddOptions.success(added);
              if (!hadChoices) return;
              $addToCartForm.after($('<p class="warning" role="alert"></p>').text('Your kit was added, but your add-on choices could not be. Add them from "Add-ons for this kit" on this page, or call (888) 406-1982.'));
            }
          }));
        };
        try {
          if (!window.bsfAddonMenu) throw new Error('bsf-addon-menu.js not loaded');
          window.bsfAddonMenu.add($addToCartForm[0], {
            start: () => bsfAddOptions.beforeSend(),
            success: added => bsfAddOptions.success(added),
            refresh: cart => { try { refreshCart(cart); } catch (err) { /* the count is cosmetic here */ } },
            fail: msg => bsfAddOptions.error({ responseText: JSON.stringify({ description: msg }) }),
            fallback: bsfFallback
          });
        } catch (err) {
          console.error('[BSF] add-on menu add failed before sending; adding the kit alone', err);
          bsfFallback();
        }
        return false;
      }
      /* /BSF-CUSTOM - addon-menus */
      $.ajax(bsfAddOptions);
      return false;
    });
  }
  /* /BSF-CUSTOM · atc-bind-first */
  window.utils.enableDisclosure();

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  try {
    window.productPage.runOptionSelector();
  } catch (error) {
    // BSF-CUSTOM · pdp-init-guard · since 2026-09-04
    // A throw in here - typically a missing global: window.kitVariantPicker (set by the
    // kit-variant-picker-bridge.js MODULE, which fails alone if an import-map dependency
    // does), or Shopify-hosted PaymentTerms / ShopifyPriceUI - must NOT abort the rest of
    // this handler (quantity box, recently viewed, accordions, currency, everything below).
    // An unguarded throw here is what hid Add to Cart store-wide on 2026-09-04 (9.6.0).
    // MERGE: keep the try/catch around whatever vendor's variant-picker init is called.
    console.error('[BSF] runOptionSelector failed; continuing page init', error);
  }
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Fancybox is loaded on demand via window.loadFancybox() (see utilities'
  // vendor script loader). Start fetching right away when this page can show
  // a lightbox, so it's ready before the user interacts.
  if (document.querySelector('[data-fancybox], .lightbox[rel="gallery"], [rel=gallery], .js-product-gallery') || window.PXUTheme.theme_settings.quick_shop_enabled || window.PXUTheme.theme_settings.newsletter_popup) {
    window.loadFancybox().then(() => {
      // backwards compatibility with custom lightboxes
      $('.lightbox[rel="gallery"]').fancybox();
    });
  }

  // Sliders visible on the page request Flickity themselves during init.
  // Quick shop galleries only need it once a quick shop is opened, so start
  // fetching early when the page has quick shop links.
  if (document.querySelector('.js-quick-shop-link')) {
    window.loadFlickity();
  }

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  if (document.querySelector('.slider, .flexslider')) {
    window.loadFlickity().then(() => {
      $('.slider, .flexslider').find('li').unwrap();
      $('.slider, .flexslider').flickity({
        pageDots: window.usePageDots,
        imagesLoaded: true,
        arrowShape: window.arrowSize,
        lazyLoad: 2
      });
    });
  }
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  window.swapCardImage = function (thumbnailEl, imageUrl) {
    if (!thumbnailEl || !imageUrl) return;
    const cardImage = thumbnailEl.querySelector('.image__container img:not(.secondary)');
    if (!cardImage) return;
    cardImage.setAttribute('src', imageUrl);
    cardImage.setAttribute('srcset', imageUrl);
  };
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.kit-swatch[data-image]', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.collection_swatches .kit-swatch[data-image]', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          window.swapCardImage($(this).parents('.thumbnail')[0], $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  // BSF-CUSTOM - addon-menus: which line a /cart/change.js answer is about. Keyed (data-line-key, every line in
  // both cart templates): by key, and a quantity > 0 whose key is gone is `stale` (keys change when a discount or
  // property changes the line). Unkeyed: by position, as the vendor did. `reread`: a kit was removed - Shopify
  // removes its nested add-ons with it and the answer need not show that - so re-read /cart.js before rendering.
  // Pure; dev/addon-menus/selftest.js runs it.
  function bsfChangedLine(items, key, lineID, quantity, hadKids) {
    if (!key) return { item: items[lineID - 1], stale: false, reread: false };
    const item = items.find(i => i.key === key);
    const removed = parseInt(quantity, 10) === 0;
    const reread = removed && (!!hadKids || items.some(i => i.parent_relationship && i.parent_relationship.parent_key === key));
    return { item, stale: !item && parseInt(quantity, 10) > 0, reread };
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      // BSF-CUSTOM - addon-menus: address the line by its key when the markup carries one (data-line-key). Line
      // numbers shift when a kit's nested add-ons are removed with it. Vendor used `line` only.
      data: cartItem.key ? {
        quantity: cartItem.quantity,
        id: cartItem.key
      } : {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const bsfLine = bsfChangedLine(data.items, cartItem.key, cartItem.lineID, cartItem.quantity, cartItem.hadKids); // BSF-CUSTOM - addon-menus
        if (bsfLine.reread) {
          // BSF-CUSTOM - addon-menus: a kit and its nested add-ons left together; count and drawer from /cart.js.
          $.ajax({ url: '/cart.js', dataType: 'json', cache: false, success: refreshCart, error: () => refreshCart(data) });
          return;
        }
        if (bsfLine.stale) {
          // BSF-CUSTOM - addon-menus: the line was re-keyed (a discount or property changed it), so this answer
          // can't say how many are left. Re-render the cart from the server instead of reading it as 0.
          if (cartItem.parentCartForm.data('cart-form') === 'cart-template') window.location.reload();
          else refreshCart(data);
          return;
        }
        const bsfApiItem = bsfLine.item; // BSF-CUSTOM - addon-menus
        const apiLineItemQuantity = typeof bsfApiItem !== 'undefined' ? bsfApiItem.quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = apiLineItemQuantity; // BSF-CUSTOM - addon-menus: the keyed line (vendor: data.items[lineIDIndex])
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }
          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      }
    });
  }
  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    const $cartForm = $('[data-cart-form]');
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
    }

    // Re-render from the header section
    const $miniCartForms = $cartForm.filter('[data-cart-form="mini-cart"]');
    const $miniCartSection = $miniCartForms.closest('.shopify-section');

    // The cart page renders no mini-cart at all when cart_action is ajax.
    if (!$miniCartSection.length) return Promise.resolve();
    const sectionId = $miniCartSection.attr('id').replace('shopify-section-', '');
    if (cartRefreshRequest) cartRefreshRequest.abort();
    cartRefreshRequest = new AbortController();
    cartRefreshId += 1;
    const refreshId = cartRefreshId;
    return fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`, {
      signal: cartRefreshRequest.signal
    }).then(response => {
      if (!response.ok) throw new Error(`Section request returned ${response.status}`);
      return response.text();
    }).then(html => {
      if (refreshId !== cartRefreshId) return;
      const rendered = new DOMParser().parseFromString(html, 'text/html');
      ['.js-cart_items', '.js-cart_discounts', '.js-cart_subtotal', '.js-cart_savings'].forEach(selector => {
        const source = rendered.querySelector(selector);

        // The full /cart page reuses these same classnames for its own
        // markup, and this fetch always pulls the mini-cart section
        // regardless of which page triggered it.
        if (source) $miniCartForms.find(selector).html(source.innerHTML);
      });
      try { bsfRestoreCartFocus($miniCartForms); } catch (err) { /* BSF-CUSTOM - addon-menus: focus after a removal (WCAG 2.4.3); never break the refresh */ }

      // Converting the currencies
      if (window.PXUTheme.currency.show_multiple_currencies) {
        window.currencyConverter.convertCurrencies();
      }
    }).catch(error => {
      if (error.name === 'AbortError') return;
      console.error('Could not refresh the mini-cart.', error);
    });
  }
  /* BSF-CUSTOM - addon-menus - since 2026-10-18
     WHAT:  (1) lines are addressed by key (data-line-key) in change/remove; (2) removing a line - or setting it to
            0 - puts focus on the line that takes its place, or the cart heading/drawer, once the cart re-renders
            (WCAG 2.4.3); on the cart page the removed kit's nested add-on inputs are disabled so the form post
            doesn't name lines Shopify already removed with the kit; (3) the "Match N kits" button on a nested
            add-on (snippets/bsf-addon-cart-line.liquid) sets that line's quantity via /cart/change.js and says
            the result in the polite status region.
     WHY:   nested add-on lines (BsfOrderHandler Dev/AddonMenus.md): Shopify removes a kit's children with it, so
            line numbers and positional updates[] shift under the vendor code.
     MERGE: keep these helpers and their calls in the two handlers below and in refreshCart. */
  let bsfFocusAfter = null;
  const bsfLineKey = $el => $el.attr('data-line-key') || null;
  const bsfHasKids = ($line, $form) => {
    const key = bsfLineKey($line);
    return !!key && $form.find(`[data-cart-item][data-parent-key="${key}"]`).length > 0;
  };
  const bsfNoteRemoval = ($line, $form) => {
    const index = $form.find('[data-cart-item]').index($line);
    if (index < 0) return;
    const key = bsfLineKey($line);
    if (key) $form.find(`[data-cart-item][data-parent-key="${key}"] input`).prop('disabled', true);
    if ($form.data('cart-form') === 'cart-template') {
      try { window.sessionStorage.setItem('bsf-cart-focus', String(index)); } catch (err) { /* focus is a nicety */ }
    } else {
      bsfFocusAfter = index;
    }
  };
  function bsfFocusLine(lines, index, fallback) {
    const line = lines[index];
    const target = (line && line.querySelector('a[href], input, button')) || fallback;
    if (!target) return;
    if (target === fallback && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: false });
  }
  function bsfRestoreCartFocus($miniCartForms) {
    if (bsfFocusAfter === null) return;
    const index = bsfFocusAfter;
    bsfFocusAfter = null;
    const drawer = $miniCartForms.closest('.cart_content')[0];
    if (!drawer || !$(drawer).is(':visible')) return;
    bsfFocusLine($miniCartForms.find('[data-cart-item]').get(), index, drawer);
  }
  if ($('body').hasClass('cart')) {
    let index = null;
    try { index = window.sessionStorage.getItem('bsf-cart-focus'); window.sessionStorage.removeItem('bsf-cart-focus'); } catch (err) { index = null; }
    if (index !== null) {
      bsfFocusLine($('[data-cart-form="cart-template"] [data-cart-item]').get(), parseInt(index, 10), document.querySelector('#MainContent h1'));
    }
  }
  $('body').on('click', '[data-bsf-addon-match]', function () {
    const btn = this;
    const $form = $(btn).closest('[data-cart-form]');
    const say = msg => {
      const r = document.getElementById('bsf-cart-status');
      if (r) { r.textContent = ''; window.setTimeout(() => { r.textContent = msg; }, 60); }
    };
    btn.disabled = true;
    $.ajax({
      url: '/cart/change.js',
      type: 'post',
      dataType: 'json',
      contentType: 'application/json',
      cache: false,
      data: JSON.stringify({ id: btn.getAttribute('data-line-key'), quantity: parseInt(btn.getAttribute('data-quantity'), 10) }),
      success(cart) {
        say('Add-on quantity updated to match your kits.');
        // The re-render replaces the button: focus goes back to the same line (WCAG 2.4.3), not to <body>.
        const key = btn.getAttribute('data-line-key');
        const $line = $(btn).closest('[data-cart-item]');
        if ($form.data('cart-form') === 'cart-template') {
          try { window.sessionStorage.setItem('bsf-cart-focus', String($form.find('[data-cart-item]').index($line))); } catch (err) { /* focus is a nicety */ }
          window.location.reload();
          return;
        }
        Promise.resolve(refreshCart(cart)).then(() => {
          const line = $form.find('[data-cart-item]').get().filter(el => el.getAttribute('data-line-key') === key)[0];
          bsfFocusLine(line ? [line] : [], 0, $form.closest('.cart_content')[0]);
        }).catch(() => { /* focus is a nicety */ });
      },
      error(xhr) {
        let detail = '';
        try { detail = JSON.parse(xhr.responseText).description || ''; } catch (err) { detail = ''; }
        btn.disabled = false;
        say(`Couldn't update that add-on. ${detail}`);
        $(btn).after($('<p class="warning" role="alert"></p>').text(`Couldn't update that add-on. ${detail} Questions? Call (888) 406-1982.`));
        $.ajax({ url: '/cart.js', dataType: 'json', cache: false, success: refreshCart });
      }
    });
  });
  /* /BSF-CUSTOM - addon-menus (cart helpers) */
  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      key: bsfLineKey($(this).parents('[data-cart-item]')), // BSF-CUSTOM - addon-menus
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.hadKids = bsfHasKids(cartItem.$element, cartItem.parentCartForm); // BSF-CUSTOM - addon-menus
    // BSF-CUSTOM - addon-menus: 0 is a removal - on the cart page the form post alone does it (see the remove handler).
    if (parseInt(cartItem.quantity, 10) === 0) {
      bsfNoteRemoval(cartItem.$element, cartItem.parentCartForm);
      if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
        cartItem.parentCartForm.submit();
        return;
      }
    }
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      key: bsfLineKey($(this).parents('[data-cart-item]')), // BSF-CUSTOM - addon-menus
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    cartItem.hadKids = bsfHasKids(cartItem.$element, cartItem.parentCartForm); // BSF-CUSTOM - addon-menus
    bsfNoteRemoval(cartItem.$element, cartItem.parentCartForm); // BSF-CUSTOM - addon-menus
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      // BSF-CUSTOM - addon-menus: the form post below is the one request (vendor also fired /cart/change.js by
      // line number first, racing it - with nested lines the two could address different lines).
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
      return;
    }
    updateCartItemQuantity(cartItem);
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });
});

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;